import React, {Component} from 'react';
import Header from '../../Layout/Header'
import {Switch, Route, Link} from 'react-router-dom'
import Circle from '../Home/Circle'
import './Blog.scss'
import EstablishingAVoiceForYourBrand from './EstablishingAVoiceForYourBrand'
import BunburyCentral from './BunburyCentral'
import BrandCharacter from './DevelopingABrandCharacter'
import HowGoogleAdwords from './HowGoogleAdwordsWorks'
import WebsiteVsSocial from './WebsiteVsSocialMediaPages'
import WhyNFPsNeed from './WhyNFPsNeed'
import DarthVader from './DarthVader'
import GoogleMasterClass from './GoogleMasterClass'
import The2020ChangesToFacebooksAlgorithm from './The2020ChangesToFacebooksAlgorithm'
import FacebookBusiness from './FacebookBusiness'
import Corona from './Corona'
import Ecommerce from './Ecommerce'
import ConsumerBehaviour from './ConsumerBehaviour'
import UX from './UX'
import CovidSocial from './CovidSocial'
import FBGroup from './FBGroup'
import SEOin2020 from './SEOin2020'
import Email2020 from './Email2020'
import EmailSigs from './EmailSigs'
import EOFYtrends from './EOFYtrends'
import StateofSocial from './StateofSocial'
import UnderstandYourMarketingData from './UnderstandYourMarketingData';


const categoryList = ["Business Strategy", "Marketing", "Branding", "Graphic Design", "Web Development"]

class Blog extends Component {
    render() {
        return (
            <div className="page-blog">
                <Switch>

<Route
                        path={`${this.props.match.path}/state-of-social-20-takeaways`}
                        component={StateofSocial}/>

<Route
                        path={`${this.props.match.path}/understand-your-marketing-data`}
                        component={UnderstandYourMarketingData}/>
<Route
                        path={`${this.props.match.path}/EOFY-marketing-trends`}
                        component={EOFYtrends}/>

<Route
                        path={`${this.props.match.path}/email-signature-best-practices`}
                        component={EmailSigs}/>


<Route
                        path={`${this.props.match.path}/using-email-as-a-marketing-tool-in-2020`}
                        component={Email2020}/>

<Route
                        path={`${this.props.match.path}/is-seo-still-relevant-in-2020`}
                        component={SEOin2020}/>

<Route
                        path={`${this.props.match.path}/how-to-avoid-spam-posts-in-facebook-groups`}
                        component={FBGroup}/>
<Route
                        path={`${this.props.match.path}/combining-ux-and-ui-to-create-converting-websites`}
                        component={UX}/>
<Route
                        path={`${this.props.match.path}/Covid-19-marketing-tools`}
                        component={CovidSocial}/>

<Route
                        path={`${this.props.match.path}/understanding-consumer-behaviour`}
                        component={ConsumerBehaviour}/>
<Route
                        path={`${this.props.match.path}/5-steps-to-creating-a-facebook-business-page`}
                        component={FacebookBusiness}/>
<Route
                        path={`${this.props.match.path}/establishing-a-voice-for-your-brand`}
                        component={EstablishingAVoiceForYourBrand}/>
<Route
                        path={`${this.props.match.path}/the-2020-changes-to-facebooks-algorithm`}
                        component={The2020ChangesToFacebooksAlgorithm}/>

<Route
                        path={`${this.props.match.path}/pivoting-your-social-strategy-around-coronavirus`}
                        component={Corona}/>

<Route
                        path={`${this.props.match.path}/ecommerce-considerations-before-bringing-your-shop-online`}
                        component={Ecommerce}/>



		<Route
                        path={`${this.props.match.path}/bunbury-central-website`}
                        component={BunburyCentral}/>
                    <Route
                        path={`${this.props.match.path}/developing-a-brand-character`}
                        component={BrandCharacter}/>
                    <Route
                        path={`${this.props.match.path}/how-google-adwords-works`}
                        component={HowGoogleAdwords}/>
                    <Route
                        path={`${this.props.match.path}/websites-vs-social-media-pages`}
                        component={WebsiteVsSocial} />
                    <Route
                        path={`${this.props.match.path}/why-nfps-need-to-become-marketing-companies`}
                        component={WhyNFPsNeed} />
                    <Route
                        path={`${this.props.match.path}/the-darth-vader-guide-to-bad-management`}
                        component={DarthVader} />
                    <Route
                        path={`${this.props.match.path}/google-store-adwords-website/`}
                        component={GoogleMasterClass} />
                    
                    <Route component={Page}/>
                </Switch>
            </div>
        );
    }
}

const Page = ({list}) => <div>

    <Header
        bg="#000000"
        seoTitle="Blog"
        title={<div> the <strong> moshi blog </strong></div>}/>
    <div className="entry-content">

      

<div className="container">
            <div className="text-center">
                <h2 className="outline">
                    <div className="line"></div>
                    <div className="title">
                        The moshiblog categories
                    </div>
                </h2>
            </div>
            <ul className="category-list">
                {categoryList.map(item => <li key={item}>{item}</li>)}
            </ul>
        </div>

<div className="container">
            <div className="row">


 <div className="col-lg-4">
                <Link to="/blog/state-of-social-20-takeaways"><Circle
                    id="22"
                    title1="10 Takeaways From"
                    title2="State of Social '20"
                    month="Nov 27"
                    year="2020"
                    desc="Marketing"
                    image={require('./StateofSocial/image-5.jpg')}
                    /></Link>
                </div>


                <div className="col-lg-4">
                <Link to="/blog/understand-your-marketing-data"><Circle
                    id="21"
                    title1="Understand Your"
                    title2="Marketing Data"
                    month="Sept 14"
                    year="2020"
                    desc="Marketing"
                    image={require('./UnderstandYourMarketingData/image.jpg')}
                    /></Link>
                </div>
                <div className="col-lg-4">
                    <Link to="/blog/EOFY-marketing-trends"><Circle
                        id="20"
                        title1="Marketing Trends"
                        title2="From This Financial Year"
                        month="June 30"
                        year="2020"
                        desc="Marketing"
                        image={require('./EOFYtrends/image.png')}
                        /></Link>
                </div>


<div className="col-lg-4">
                    <Link to="/blog/email-signature-best-practices"><Circle
                        id="19"
                        title1="Email Signature"
                        title2="Best Practices"
                        month="June 25"
                        year="2020"
                        desc="Graphic Design"
                        image={require('./EmailSigs/image.jpg')}/></Link>
               
 </div>


<div className="col-lg-4">
                    <Link to="/blog/using-email-as-a-marketing-tool-in-2020"><Circle
                        id="18"
                        title1="Using Email as a"
                        title2="Marketing Tool in 2020"
                        month="June 10"
                        year="2020"
                        desc="Marketing"
                        image={require('./Email2020/image.jpg')}/></Link>
               
 </div>



<div className="col-lg-4">
                    <Link to="/blog/is-seo-still-relevant-in-2020"><Circle
                        id="17"
                        title1="Is SEO Still"
                        title2="Relevant in 2020?"
                        month="June 3"
                        year="2020"
                        desc="Website Development"
                        image={require('./SEOin2020/image-7.jpg')}/></Link>
               
 </div>


<div className="col-lg-4">
                    <Link to="/blog/how-to-avoid-spam-posts-in-facebook-groups"><Circle
                        id="16"
                        title1="How To Avoid Spam Posts"
                        title2="In Facebook Groups"
                        month="May 28"
                        year="2020"
                        desc="Marketing"
                        image={require('./FBGroup/image.png')}/></Link>
               
 </div>

<div className="col-lg-4">
                    <Link to="/blog/Covid-19-marketing-tools"><Circle
                        id="15"
                        title1="COVID-19"
                        title2="Marketing Tools"
                        month="May 20"
                        year="2020"
                        desc="Marketing"
                        image={require('./CovidSocial/image-2.jpg')}/></Link>
               
 </div>


<div className="col-lg-4">
                    <Link to="/blog/combining-ux-and-ui-to-create-converting-websites"><Circle
                        id="14"
                        title1="Combining UX and UI to"
                        title2="Create Converting Websites"
                        month="May 11"
                        year="2020"
                        desc="Web Development"
                        image={require('./UX/image-2.jpg')}/></Link>
               
 </div>






<div className="col-lg-4">
                    <Link to="/blog/understanding-consumer-behaviour"><Circle
                        id="13"
                        title1="Understanding Consumer Behaviour"
                        title2="in Marketing and Design"
                        month="May 07"
                        year="2020"
                        desc="Marketing"
                        image={require('./ConsumerBehaviour/image-1.jpg')}/></Link>
               
 </div>



<div className="col-lg-4">
                    <Link to="/blog/5-steps-to-creating-a-facebook-business-page"><Circle
                        id="12"
                        title1="5 Easy Steps to Creating"
                        title2="a Facebook Business Page"
                        month="April 28"
                        year="2020"
                        desc="Marketing"
                        image={require('./FacebookBusiness/image.jpg')}/></Link>
               
 </div>




<div className="col-lg-4">
                    <Link to="/blog/ecommerce-considerations-before-bringing-your-shop-online"><Circle
                        id="11"
                        title1="Ecommerce: Considerations Before"
                        title2="Bringing Your Shop Online"
                        month="April 21"
                        year="2020"
                        desc="Marketing"
                        image={require('./Ecommerce/image.jpg')}/></Link>
               
 </div>
<div className="col-lg-4">
                    <Link to="/blog/pivoting-your-social-strategy-around-coronavirus"><Circle
                        id="10"
                        title1="Pivoting Your Social Strategy"
                        title2="Around Coronavirus"
                        month="April 01"
                        year="2020"
                        desc="Marketing"
                        image={require('./Corona/Ross.jpg')}/></Link>
               
 </div>



<div className="col-lg-4">
                    <Link to="/blog/the-2020-changes-to-facebooks-algorithm"><Circle
                        id="9"
                        title1="The 2020 Facebook Changes"
                        title2="All Businesses Should Know"
                        month="Feb 27"
                        year="2020"
                        desc="Marketing"
                        image={require('./The2020ChangesToFacebooksAlgorithm/image.jpg')}/></Link>
               
 </div>





<div className="col-lg-4">
                    <Link to="/blog/establishing-a-voice-for-your-brand"><Circle
                        id="8"
                        title1="Establishing a Voice"
                        title2="For Your Brand"
                        month="Feb 12"
                        year="2020"
                        desc="Branding"
                        image={require('./EstablishingAVoiceForYourBrand/image.jpg')}/></Link>
               
 </div>


   
			<div className="col-lg-4">
                    <Link to="/blog/bunbury-central-website">
                        <Circle
                            id="7"
                            title1="Bunbury Central"
                            title2="Website"
                            month="Nov 20"
                            year="2018"
                            desc="Web Development"
                            image={require('./BunburyCentral/image.jpg')}/>
                    </Link>
                </div>


                <div className="col-lg-4">
                    <Link to="/blog/how-google-adwords-works">
                        <Circle
                            id="1"
                            title1="How Google Adwords"
                            title2="Works"
                            month="Apr 13"
                            year="2018"
                            desc="Marketing"
                            image={require('./HowGoogleAdwordsWorks/image.jpg')}/>
                    </Link>
                </div>




                <div className="col-lg-4">
                    <Link to="/blog/developing-a-brand-character"><Circle
                        id="2"
                        title1="Developing a brand"
                        title2="character"
                        month="Jun 18"
                        year="2016"
                        desc="Design"
                        image={require('./DevelopingABrandCharacter/image.jpg')}/></Link>
                </div>
                
<div className="col-lg-4">
                    <Link to="/blog/websites-vs-social-media-pages"><Circle
                        id="3"
                        title1="Websites vs Social"
                        title2="Media Pages"
                        month="Oct 23"
                        year="2017"
                        desc="Marketing"
                        image={require('./WebsiteVsSocialMediaPages/image.jpg')}/></Link>
               
 </div>
                <div className="col-lg-4">
                    <Link to="/blog/why-nfps-need-to-become-marketing-companies"><Circle
                        id="4"
                        title1="Why NFPs Need To Become"
                        title2="Marketing Companies"
                        month="Jun 13"
                        year="2015"
                        desc="Marketing"
                        image={require('./WhyNFPsNeed/image.jpg')}/></Link>
                </div>

                <div className="col-lg-4">
                    <Link to="/blog/the-darth-vader-guide-to-bad-management"><Circle
                        id="5"
                        title1="The Darth Vader Guide"
                        title2="to Bad Management"
                        month="Jun 20"
                        year="2016"
                        desc="Marketing"
                        image={require('./DarthVader/image.jpg')}/></Link>
                </div>

                 <div className="col-lg-4">
                    <Link to="/blog/google-store-adwords-website/"><Circle
                        id="6"
                        title1="What Google Has In Store"
                        title2="For Adwords"
                        month="Sept 28"
                        year="2016"
                        desc="Marketing"
                        image={require('./GoogleMasterClass/image.jpg')}/></Link>
                </div>
         </div>
        </div>

         </div>
        </div>

export default Blog;


// WEBPACK FOOTER //
// ./src/Pages/Blog/Blog.js